import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detalle-b',
  templateUrl: './detalle-b.component.html',
  styleUrls: ['./detalle-b.component.scss']
})
export class DetalleBComponent implements OnInit {

  Relacionados: any[] = [
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png',
      titulo: '¿Cómo hacer dropshipping?',
      parrafo: 'A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para sim...'
    }
  ]

  constructor() { }

  ngOnInit(): void {
  }

}
